import storage from 'redux-persist/es/storage';
import {persistCombineReducers} from 'redux-persist';

import auth from './auth';
import messages from './messages';

const storageConfig = {
    whitelist: 'auth',
    key: 'certification_storage',
    storage
};

export default persistCombineReducers(storageConfig, {auth, messages});